import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AgentsService } from '@app/services/agents.service';
import { SharedService } from '@app/services/shared.service';
import { SharedModalComponent } from '@shared/components/modal/modal.component';
import { AnalyticsService } from '@shared/services/analytics.service';
import { IAgent } from 'libs/shared/src/lib/interfaces';

@Component({
  selector: 'blu-add-agent',
  templateUrl: './add-agent.component.html',
  styleUrls: ['./add-agent.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [SharedModalComponent, FormsModule],
})
export class AddAgentComponent {
  loading = false;
  agent: IAgent = {
    uid: '',
    name: '',
    organization: '',
    createdAt: new Date(),
    deletedAt: new Date(),
    configuration: {
      prompt: '',
    },
  };

  constructor(
    public sharedService: SharedService,
    public route: ActivatedRoute,
    private router: Router,
    private agentsService: AgentsService,
    public analyticsService: AnalyticsService,
  ) {}

  async save(): Promise<void> {
    if (!this.agent) return;
    try {
      this.loading = true;
      const newAgentDocRef = await this.agentsService.createAgent(this.agent);
      this.sharedService.closeModal(this.route);
      this.router.navigateByUrl(`/admin/chat/agents/${newAgentDocRef.id}`);
    } finally {
      this.loading = false;
    }
  }
}
